import { createModel } from "hox";
import React, { useState } from "react";
import { IOrganRemove, IOrganSearch, IOrganUpdate, IOrganInsert, IOrganDetail, IOrganParams, IOrganDisable, OptType } from "./organizationTypes"
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "../../../../utils/constants";
import { IPgProps, ISearchPage } from "../../../../types/FmsTypes";
import { organService } from "./organizationService"
import { globalPrompt } from "../../../../components/YhMessage";
import { filterArrId, transPgToPagination } from "../../../../utils/utils"

type dictObj = {
    [key: string]: any
}
function listChangeTree(list: IOrganDetail[]) {
    let menuObj: dictObj = {}
    list.forEach(item => {
        item.children = []
        menuObj[item.code as string] = item
    })
    return list.filter(item => {
        if (item.pcode !== null && item.pcode !== "") {
            menuObj[item.pcode as string]?.children.push(item)
            return false
        }
        return true
    })
}
export const useOrganizationModel = createModel(function () {
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initSearchParams: IOrganParams = {}
    const initOrganList: IOrganDetail[] = []

    const [searchParam, setSearchParam] = useState<IOrganParams>(initSearchParams)
    // const [organList,setOrganList] = useState<IOrganDetail[]>(initOrganList)
    const [organTree, setOrganTree] = useState([])
    const [organTreeRowKey, setOrganTreeRowKey] = useState<React.Key[]>([])
    const [organTreeRow, setOrganTreeRow] = useState<IOrganDetail>({})
    const [organTreePRow, setOrganTreePRow] = useState<IOrganDetail>({})
    const [addTreeFrom, setAddTreeFrom] = useState<IOrganInsert>({});
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    const [optType, setOptType] = useState<number>(1)
    const [root, setRoot] = useState<boolean>(false)
    const upDataSearchParam = (upDataParam: IOrganParams) => {
        setSearchParam({ ...searchParam, ...upDataParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: IOrganParams) => {
        const searchParams = data ?? searchParam
        const parsms = {
            ...searchParams,
            page: {
                pageSize: 10000,
                pageNum: 1
            }
        }
        const { retData } = await organService.page(parsms)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        // const arrSort = records.sort((a: any, b: any) => a.code.length - b.code.length)
        setOrganTree(listChangeTree(records) as never[])
    }
    const changeTreeForm = (value: any) => {
        console.log(value)
        setOrganTreeRow({ ...organTreeRow, ...value })
    }
    const insertTreeForm = (value: any) => {
        console.log(value)
        setAddTreeFrom({ ...addTreeFrom, ...value })
    }
    const updataTreeForm = async (value: any) => {
        const params = {
            ...organTreeRow,
            ...value,
            enable: value.enable ? 1 : 0,
            sourceApp: "vrm",

        }
        const { retData, retMsg } = await organService.update(params)
        await globalPrompt("message", { type: "success", text: retMsg });
        await loadData()
        setOptType(OptType.DETAIL);
    }
    const addPeerTreeForm = async (value: any) => {
        const params = {
            ...addTreeFrom,
            ...value,
            enable: value.enable ? 1 : 0,
            sourceApp: "vrm",

        }
        const { retData, retMsg } = await organService.insert(params)
        await globalPrompt("message", { type: "success", text: retMsg });
        await loadData()
        setOptType(OptType.DETAIL);
    }
    const removeTreeForm = async () => {
        const params = {
            ...organTreeRow,
            enable: organTreeRow.enable ? 1 : 0,
            sourceApp: "vrm",

        }
        const { retData, retMsg } = await organService.remove(params)
        await globalPrompt("message", { type: "success", text: "删除成功" });
        await loadData()
    }
    const mapTree = (org: any): any => {
        const haveChildren = Array.isArray(org?.children) && org?.children.length > 0;
        return {
            title: org?.name ?? "",
            value: org?.code ?? "",
            //判断它是否存在子集，若果存在就进行再次进行遍历操作，知道不存在子集便对其他的元素进行操作
            children: haveChildren ? org.children.map((i: any) => mapTree(i)) : []
        };
    }
    const getOrgTreeSelect = async (code: any): Promise<any[]> => {
        const parsms = {
            page: {
                pageSize: 10000,
                pageNum: 1
            }
        }
        const { retData } = await organService.page(parsms)
        const { records, ...pg } = retData
        // listChangeTree(records) 
        return [mapTree(listChangeTree(records)[0])]
    }
    return {
        searchParam,
        organTree,
        organTreeRowKey,
        organTreeRow,
        organTreePRow,
        page,
        optType,
        root,
        addTreeFrom,
        setAddTreeFrom,
        setSearchParam,
        setOrganTree,
        setOrganTreeRowKey,
        setOrganTreeRow,
        setOrganTreePRow,
        setPage,
        setOptType,
        setRoot,
        loadData,
        upDataSearchParam,
        resetSearchParam,
        changeTreeForm,
        insertTreeForm,
        updataTreeForm,
        addPeerTreeForm,
        removeTreeForm,
        getOrgTreeSelect
    }
});